import React from 'react'
import { Button } from 'reactstrap'

export default ({ text, loggedIn, onClick, isOpen }) => {
  return loggedIn ? (
    <div className="d-flex mb-3 mt-3 flex-wrap">
      <h1 className="mr-auto text-dark">Адрес: {text || 'null'}</h1>
      <Button color={isOpen ? 'success' : 'warning'} onClick={onClick}>
        {isOpen ? 'Открыто' : 'Открыть дверь'}
      </Button>
    </div>
  ) : (
    <div className="d-flex mb-3 mt-3">
      <h1 className="text-dark">Демо камера</h1>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/home/HomeHeader.js